var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgZerion(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M367.223 512H144.777C64.8348 512 0 447.194 0 367.223V144.777C0 64.8349 64.8057 0 144.777 0H367.223C447.165 0 512 64.8057 512 144.777V367.223C512 447.194 447.165 512 367.223 512Z",
    fill: "#2461ED"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M292.851 249.19C242.657 222.066 181.584 186.893 135.62 158.223C122.058 148.453 128.941 127.716 145.332 127.716H372.764C385.451 127.716 393.938 141.861 387.58 152.565C372.297 178.96 349.986 212.471 331.349 239.041C321.345 253.302 305.042 255.752 292.851 249.19ZM219.645 257.998C268.177 283.868 336.191 323.212 384.518 352.961C399.451 362.177 393.501 384.284 376.06 384.284C347.52 384.284 301.144 384.292 255.009 384.299C209.35 384.306 163.926 384.313 136.261 384.313C122.32 384.313 115.175 369.847 121.095 359.756C141.103 325.662 163.589 291.246 182.284 265.552C190.597 254.09 207.513 251.523 219.645 257.998Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_14"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZerion);
export default __webpack_public_path__ + "static/media/zerion.93fda728f8f29b266c6e4153184a637d.svg";
export { ForwardRef as ReactComponent };